export const getOrderedDishOption = (orderedDishOptions, id) =>
    orderedDishOptions.find((orderedDishOption) => orderedDishOption.id === id);

export const getOrderedDishOptionValue = (orderedDishOptions, id) => {
    const orderedDishOption = getOrderedDishOption(orderedDishOptions, id);
    return orderedDishOption && orderedDishOption.value;
};
